import client from './client';
import _ from 'lodash';
const userUrl = '/api/v1/user';

//유저 리스트 가져오기
export const getUsers = () => {
  return client.get(`${userUrl}/list`);
};

// 영업사원 리스트 가져오기
export const getSalesUsers = () => {
  return client.get(`${userUrl}/list/role/SALES`);
};

export const getUsersForMention = () => {
  return client.get(`${userUrl}/list`).then((res) => {
    if (res.data.list) {
      const users = _.map(res.data.list, function (user) {
        return {
          id: user.usrUuid,
          value: user.usrNm,
          profileImg: user.profileImg,
        };
      });
      return users;
    }
    return [];
  });
};
